module.exports = __webpack_public_path__ + "static/media/first-order-alt.7373bf1f.svg";